module.exports = __webpack_public_path__ + "static/media/pixelmask_logo.9666b726.png";